// extracted by mini-css-extract-plugin
export default {"recycleList":"RecycleList_recycleList__OrR9K","list":"RecycleList_list__4Vzh6"};